import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

// 200(정상처리) 와 500(서버오류) 를 제외한 나머지 오류를 처리하기위한 장소
const ErrorAxios = () => {
  const params = useParams();
  // const { error } = useSelector((state) => state.vodStore);

  return (
    <div style={{position: 'relative', paddingTop: '5%', paddingLeft: '5%', color: 'red', fontWeight: '900'}}>
      <div>{params.errCode}</div>
      {/* <div>{error}</div> */}
      ※동영상을 재생할 수 없습니다.<br/>다시 시도해주세요. 
    </div>
  );
};

export default ErrorAxios;
